import React, { useEffect, useState, Suspense } from "react";
import { useDispatch } from "react-redux";
import { selectPortalType } from "./modules/auth/actions";
import Layout from "./core/components/Layout/Layout";
import PrivateRoutes from "./routes/PrivateRoutes";
import { useSelector } from "react-redux";
import StorageUtil from "./utils/storageUtil";
import viewUtility from "./utils/viewUtility";
import routeConfig from "./routes/routeMap";
import lodash from "lodash";
import version from "./majorVersion";

const Main = () => {
  const majorVersion = StorageUtil.getData(viewUtility.MAJOR_VERSION);
  const dispatch = useDispatch();

  if (!majorVersion || majorVersion < version) {
    StorageUtil.removeAll();
    StorageUtil.saveData(viewUtility.MAJOR_VERSION, version);
  }

  const { userInfo, portalType } = useSelector((state) => ({
    userInfo: state.auth.userInfo,
    portalType: state.auth.portalType,
  }));

  const [menuAndRoutes, setMenuAndRoutes] = useState({ portalList: [], menu: [], routes: [] });

  useEffect(() => {
    const storedUserInfo = StorageUtil.getObject(viewUtility.USER_DATA);
    if (storedUserInfo && storedUserInfo.uiRouteList) {
      const portalRouteList = storedUserInfo.uiRouteList;
      if (portalRouteList[0]) {
        const currentPortalType = StorageUtil.getObject(viewUtility.PORTAL_TYPE);
        const updatedPortalType = currentPortalType
          ? currentPortalType
          : { label: portalRouteList[0].viewName, value: portalRouteList[0].viewName };
        StorageUtil.saveObject(viewUtility.PORTAL_TYPE, updatedPortalType);
        dispatch(selectPortalType(updatedPortalType));
      }
    } else {
      setMenuAndRoutes({ portalList: [], menu: [], routes: [] });
    }
  }, [userInfo]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (portalType) {
      const storedUserInfo = StorageUtil.getObject(viewUtility.USER_DATA);
      const { portalList, menu, routes } = getUserMenuAndRoutes(storedUserInfo, portalType);      
      setMenuAndRoutes({ portalList, menu, routes });
    }
  }, [portalType]); //eslint-disable-line react-hooks/exhaustive-deps

  const getUserMenuAndRoutes = (userInfo) => {
    const portalRouteList = lodash.cloneDeep(userInfo.uiRouteList, portalType);
    
    const portalList = [];
    const menu = {};
    const routes = [];
    let homeUrl = false;

    if (!portalRouteList) {
      return { portalList, menu, routes };
    }

    portalRouteList.forEach((portal) => {
      portalList.push({ label: portal.viewName, value: portal.viewName });
      menu[portal.viewName] = [];

      portal.routeList.forEach((currentRouteList) => {
        
        const menuConfig = { ...currentRouteList, subMenus: [] };
        
        menuConfig?.routes && menuConfig.routes.forEach((currentRoute) => {
          if (!routeConfig[currentRoute.key]) {
            return;
          }

          if (!routeConfig[currentRoute.key].notMenu) {
            const currentRouteConfig = { ...routeConfig[currentRoute.key], ...currentRoute };
            menuConfig.subMenus.push(currentRouteConfig);
          }

          const currentPortalType = StorageUtil.getObject(viewUtility.PORTAL_TYPE);
          if (!homeUrl && !routeConfig[currentRoute.key].notMenu && (!currentPortalType || currentPortalType.value === portal.viewName)) {
            homeUrl = true;
            routes.push({ ...routeConfig[currentRoute.key], homeUrl: true, activeMenu: currentRouteList.key, routeKey: currentRoute.key });
          } else {
            routes.push({ ...routeConfig[currentRoute.key], activeMenu: currentRouteList.key, routeKey: currentRoute.key });
          }
        });
        menu[portal.viewName].push(menuConfig);
      });
    });

    return { portalList, menu, routes };
  };

  return (
    <Layout portalType={portalType} menu={portalType ? menuAndRoutes.menu[portalType.value] : []} portalList={menuAndRoutes.portalList}>
      <Suspense fallback={<></>}>
        <PrivateRoutes routes={menuAndRoutes.routes} />
      </Suspense>
    </Layout>
  );
};

export default React.memo(Main);
